module.exports = __webpack_public_path__ + "img/default.c776f05b.png";